import { render, staticRenderFns } from "./UnpaidView.vue?vue&type=template&id=6ba2806e&"
import script from "./UnpaidView.vue?vue&type=script&lang=js&"
export * from "./UnpaidView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports